import usePageMetadata from '@hooks/usePageMetadata'
import useTracking, { TrackingFnType } from '@hooks/useTracking'
import { FunctionComponent, useCallback, useEffect } from 'react'
import { getPageViewType } from './utils'

const TrackPageView: FunctionComponent = () => {
  const { url } = usePageMetadata()
  const onImpression = useCallback<TrackingFnType>(({ pageMetadata }) => {
    const {
      fromSeo,
      isSeoOptimized,
      lifespan,
      isExclusive,
      sectionUniqueNames,
      ressort,
    } = pageMetadata

    const type = getPageViewType(pageMetadata)
    let eventData: Record<string, unknown> = {}

    switch (type) {
      case 'home': {
        eventData = { event: 'home_page_view' }
        break
      }
      case 'section': {
        eventData = { event: 'section_page_view' }
        break
      }
      case 'article': {
        eventData = {
          ...{
            pageRessort: sectionUniqueNames?.[sectionUniqueNames.length - 1],
          },
          ...(typeof fromSeo === 'boolean' &&
          typeof isSeoOptimized === 'boolean'
            ? {
                articleSEO: `bySEO:${fromSeo ? 1 : 0},optSEO:${
                  isSeoOptimized ? 1 : 0
                }`,
              }
            : {}),
          ...(typeof isExclusive === 'boolean' && typeof lifespan === 'string'
            ? { articleLife: `ex:${isExclusive ? 1 : 0},lt:${lifespan}` }
            : {}),
          ressort,
          event: 'article_page_view',
        }
        break
      }
      case 'dossier': {
        eventData = { event: 'dossier_page_view' }
        break
      }
      default: {
        break
      }
    }

    return eventData
  }, [])

  const trackOnImpression = useTracking(onImpression)

  useEffect(() => {
    trackOnImpression()
  }, [trackOnImpression, url])

  return null
}

export default TrackPageView
